import { render, staticRenderFns } from "./SourcesBrowse.vue?vue&type=template&id=5a0b821b&scoped=true"
import script from "./SourcesBrowse.vue?vue&type=script&lang=js"
export * from "./SourcesBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b821b",
  null
  
)

export default component.exports